module.exports = __webpack_public_path__ + "static/media/carousel-bg.28161605.png";